module.exports = __webpack_public_path__ + "img/object-feature-object-after.8408c8ad.webp";